<template>
  <div class="page-header" style="background: url(/img/banner1.jpg)">
    <div class="container">
      <div class="row">
        <div class="col-md-12 mt-5">
          <div class="breadcrumb-wrapper">
            <h2 class="product-title">Conditions générales d'utilisations</h2>
            <ol class="breadcrumb">
              <li>
                <a href="/"><i class="ti-home"></i> Accueil</a>
              </li>
              <li class="current">Conditions générales d'utilisations</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header.vue",
};
</script>

<style scoped></style>
